<template>
  <div class="form__field" v-show="currentStep" v-if="shouldShow">
    <div class="form__field__group">
      <a
        class="button button--bordered button--primary-light"
        v-show="currentIndex > 0"
        @click="goToPrevStep()"
      >
        <span class="button__icon icon-left-open-big"></span>
        <span class="button__label">{{ currentStep.buttonPrev }}</span>
      </a>
      <a
        class="button button--bordered button--primary"
        @click="goToNextStep()"
      >
        <span class="button__label">{{ currentStep.buttonNext }}</span>
        <span class="button__icon icon-right-open-big"></span>
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  props: ["steps"],
  name: "checkout-navigation",
  computed: {
    currentIndex: function() {
      return Math.max(this.steps.findIndex(step => step.active), 0);
    },
    currentStep: function() {
      return this.steps[this.currentIndex];
    },
    shouldShow: function() {
      // Auth step
      if (this.currentIndex === 1) {
        const authField = this.$store.state.fields.find(
          field => field.name === "auth"
        );
        // Confirm message view
        if (authField && authField.value === "confirmMessage") {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    goToNextStep: async function() {
      if (
        this.currentIndex < this.steps.length - 1 &&
        this.$store.state.api.magicSave
      ) {
        await axios.post(
          this.$store.state.api.magicSave || "",
          qs.stringify({
            ...this.$store.state.api.params,
            state: JSON.stringify(this.$store.state)
          })
        );

        await this.$store.dispatch("updateSteps", {
          activeIndex: this.currentIndex + 1
        });
      } else {
        await this.$store.dispatch("saveState");
      }

      document.getElementById('step').scrollIntoView();
    },
    goToPrevStep: function() {
      if (this.currentIndex > 0) {
        this.$store.dispatch("updateSteps", {
          activeIndex: this.currentIndex - 1
        });
      }
      
      document.getElementById('step').scrollIntoView();
    }
  }
};
</script>
